<template>
    <div class="helpMain">
        <p class="titleMain">当前位置： 
            <span>内容中心</span>
        </p>
        <div class="contextMain">
            <div class="left_title">
              <p :class="id == '1829'?'activeCss':''" @click="HandleId('1829')">企链工大事件</p>
              <p :class="id == '1830'?'activeCss':''" @click="HandleId('1830')">客户案例</p>
              <p :class="id == '1831'?'activeCss':''" @click="HandleId('1831')">产品知识</p>
            </div>
            <div class="helpContext">
                <!-- <p class="contextTitle">企链工大事件</p> -->
                <div>
                  <div v-for="item in list" :key="item.id"  class="context" @click="HandleInfoId(item.id)">
                    <div>
                      <img :src="item.firstFile.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                    </div>
                    <div>
                      <p>{{ item.title }} </p>
                      作者： {{ item.author }}
                    </div>
                    <div>
                      发布时间： {{ item.create_time }}
                    </div>
                  </div>
                  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getTimeDate } from '@/js/getTime'
export default{
    data(){
        return{
          id: '',
          list: []
        }
    },
    methods: {
        getList(){
          let data = {
                channel: 'content_center',
                cate_id: this.id,
                pageSize: 10,
                pageNum: 1
            }
            this.$store.dispatch('help/listarticle',data)
                .then(res => {
                    if(res.ok){
                      this.list = res.data.items
                      this.list.forEach(item => {
                        item.create_time = getTimeDate(item.create_time)
                      });
                    }
                })
        },
        HandleId(val){
          this.id = val
          this.getList()
        },
        HandleInfoId(id){

          this.$router.push({
            path: '/detailPages',
            query: {
              key: id,
              currentName: '内容中心'
            }
          })
        }
    },
    created(){
        this.id = this.$route.query.id
        this.getList()
       
    
    }
}
</script>
<style scoped lang="scss">
.helpMain{
    width: 1200px;min-height: calc(100vh - 190px);
    padding: 10px 10px;
    margin: 45px auto;
    .titleMain{
        margin-top: -45px;
        font-size: 17px;
        color: #333;
        span{
            font-size: 16px;
            cursor: pointer;
            color: #666666;
        }
    }
    .contextMain{
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        .left_title{
          width: 250px;
          background-color: #ffffff;
          text-align: center;
          cursor: pointer;
          padding: 20px 6px;
          p{
             line-height: 50px;
          }
          p:hover{
            color: #10aeff;
          }
          .activeCss{
            color: #10aeff;
          }
        }
        
        .helpContext{
            width: 930px;min-height: calc(100vh - 190px);
            background: #ffffff;
            .contextTitle{
                font-size: 18px;
                color: #333333;
                font-weight: 700;
                padding: 10px 25px;
            }
            .context{
                margin-top: 60px;
                padding: 10px 25px 50px 25px;
                height: 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 0.5px solid #f2f2f2;
                cursor: pointer;
                div{
                  
                  font-size: 16px;
                  color: #666666;
                  p{
                    width: 500px;
                    margin-bottom: 15px;
                    color: #333333;
                    font-size: 18px;
                    font-weight: 600;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  }
                }
                div:nth-child(1){
                  width: 100px;
                  height: 100px;
                  background-size: cover;
                  background-repeat: no-repeat;
                  background-position: center;
                }
                div:nth-child(2){
                  margin-top: 35px;
                }
            }
        }
    }
}
</style>